import {NgModule} from '@angular/core';
import {FirstletterupperPipe} from './firstletterupper.pipe';

@NgModule({
  imports:[],
  declarations:[
    FirstletterupperPipe
  ],
  exports:[
    FirstletterupperPipe
  ]
})
export class PipesModule {
}
